import type { Meeting } from '@/types/meeting';
import axios from '@/lib/v2/axios';

export async function getMeeting(meetingId: string): Promise<Meeting | null> {
  try {
    const response = await axios.get(`/api/v1/meetings/${meetingId}`);
    return response.data;
  } catch {
    return null;
  }
}

export async function getMeetings(): Promise<Meeting[]> {
  const response = await axios.get('/api/v1/meetings');
  const data = response.data;
  return Array.isArray(data) ? data : data?.data ?? [];
}

export async function deleteMeeting(meetingId: string | number): Promise<void> {
  await axios.delete(`/api/v1/meetings/${meetingId}`);
}
